import { ReactElement, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useFlags } from '@flagsmith/flagsmith/react';
import { Component as BoxIcon } from 'icons/icon-box.svg';
import { Component as CircleLeafIcon } from 'icons//icon--circle-leaf.svg';
import { Component as GroceryBagIcon } from 'icons/icon--grocery-bag.svg';
import { WhatsInYourBox } from 'platform/components/order-confirmation/WhatsInYourBox';
import { OrderReceipt } from 'platform/components/order-confirmation/OrderReceipt';
import { Route } from '../../utils/config';
import { WhatToKnow } from './WhatToKnow';
import { OrderInformation } from './OrderInformation';
import { WhileYouWait } from './WhileYouWait';
import styles from './OrderConfirmation.module.scss';

export function OrderConfirmationPage(): ReactElement {
  const flags = useFlags(['order_confirmation_page']);
  const isOrderConfirmationEnabled = flags.order_confirmation_page?.enabled;

  // Read and clear the flag so a refresh redirects to hub instead of re-showing the page
  const isValidVisit = useRef(sessionStorage.getItem('fromPayment') === 'true');
  sessionStorage.removeItem('fromPayment');

  if (!isOrderConfirmationEnabled || !isValidVisit.current) {
    return <Navigate to={Route.HUB} replace />;
  }

  const whatToKnowSections = [
    {
      title: 'Good food for the whole week.',
      body: 'Dinnertime, snacktime, or anytime - one delivery per week, endless easy options.',
      icon: <GroceryBagIcon width={56} height={56} />,
    },
    {
      title: 'Totally flexible subscription.',
      body: 'Shop ahead of time, or skip an upcoming delivery up to four weeks in advance.',
      icon: <BoxIcon width={56} height={56} />,
    },
    {
      title: 'Healthy you’ll look forward to.',
      body: <>
        New menus every week, refreshed to keep
        {' '}
        <em>healthy</em>
        {' '}
        feeling exciting.
      </>,
      icon: <CircleLeafIcon width={56} height={56} />,
    },
  ];

  return (
    <>
      <div className={styles.page}>
        <OrderInformation />
      </div>
      <WhatToKnow sections={whatToKnowSections} />
      <div className={styles.page}>
        <WhileYouWait />
        <div className={styles.breakdown}>
          <WhatsInYourBox />
          <OrderReceipt />
        </div>
      </div>
    </>
  );
}
